import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosAplicacionesService,
  CultivoTratamientoItem,
} from "../../../../generated/grpc/catalogos_aplicaciones_pb";

/** Variante gRPC-Web (con delta) de `CultivoTratamientoGetCatalogService` (ver ese archivo). */
export class CultivoTratamientoGrpcCatalogService extends BaseGrpcCatalogService<CultivoTratamientoItem> {
  protected readonly storeName = "cultivoTratamientos" as const;
  protected readonly sortFieldName = "tratamiento";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<CultivoTratamientoItem>> {
    const client = createClient(CatalogosAplicacionesService, grpcTransportProvider.get());

    try {
      const response = await client.listCultivoTratamientos({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de tratamientos de cultivo. */
export const cultivoTratamientoGrpcCatalogService = new CultivoTratamientoGrpcCatalogService();
